import { render, staticRenderFns } from "./drawer-minimal.vue?vue&type=template&id=744f6fe0&"
import script from "./drawer-minimal.vue?vue&type=script&lang=js&"
export * from "./drawer-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports